import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/general/geAttachment/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/general/geAttachment',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/general/geAttachment',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/general/geAttachment/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/general/geAttachment',
    method: 'get',
    params: {
      id
    }
  })
}
